export enum KeyboardKey {
	Zero = '0',
	One = '1',
	Two = '2',
	Three = '3',
	Four = '4',
	Five = '5',
	Six = '6',
	Seven = '7',
	Eight = '8',
	Nine = '9',
	Backspace = 'Backspace',
	Tab = 'Tab',
	Enter = 'Enter',
	Shift = 'Shift',
	Escape = 'Escape',
	SpaceBar = 'Space',
	ArrorwLeft = 'ArrowLeft',
	ArrowUp = 'ArrowUp',
	ArrowRight = 'ArrowRight',
	ArrowDown = 'ArrowDown'
}

export const KeyboardCancelKeys: KeyboardKey[] = [KeyboardKey.Escape];

export const KeyboardNavigationKeys: KeyboardKey[] = [
	KeyboardKey.Tab,
	KeyboardKey.Enter,
	KeyboardKey.Escape,
	KeyboardKey.SpaceBar,
	KeyboardKey.ArrorwLeft,
	KeyboardKey.ArrowUp,
	KeyboardKey.ArrowRight,
	KeyboardKey.ArrowDown
];

export const KeyboardArrowKeys: KeyboardKey[] = [KeyboardKey.ArrorwLeft, KeyboardKey.ArrowUp, KeyboardKey.ArrowRight, KeyboardKey.ArrowDown];

export const KeyboardSaveKeys: KeyboardKey[] = [KeyboardKey.Tab, KeyboardKey.Enter];

export const KeyboardNumberKeys: KeyboardKey[] = [
	KeyboardKey.Zero,
	KeyboardKey.One,
	KeyboardKey.Two,
	KeyboardKey.Three,
	KeyboardKey.Four,
	KeyboardKey.Five,
	KeyboardKey.Six,
	KeyboardKey.Seven,
	KeyboardKey.Eight,
	KeyboardKey.Nine
];
